import { createSelector } from 'reselect';
import OriginImpcOperatorPredesSenderMismatchDetailsColumns from '../../containers/OriginImpcOperatorPredesSenderMismatchDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';


export const getGeneratedOnDateTime =
  state => state.reporting.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS.isLoading;

export const getData =
  ReportDefinitions.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, OriginImpcOperatorPredesSenderMismatchDetailsColumns);
